<section class="test-progress" [attr.aria-labelledby]="headingId">
  <to-section-title
    [headingId]="headingId"
    [title]="'liveDashboard.testmanager.progress.title' | translate"
    [subtitle]="'liveDashboard.testmanager.progress.subtitle' | translate"
  />

  <div class="test-progress__list">
    @for (row of rows(); track row.projectId) {
      <div class="test-progress__row">
        <div class="test-progress__row-head">
          <a
            class="test-progress__row-link"
            [routerLink]="row.requirementsLink"
            [attr.aria-label]="
              'liveDashboard.testmanager.progress.toProjectRequirements' | translate: { name: row.name }
            "
          >
            <span class="test-progress__dot" [style.background]="'var(' + row.colorVar + ')'" aria-hidden="true"></span>
            <span class="test-progress__name-text">{{ row.name }}</span>
            <mat-icon class="test-progress__chevron" fontSet="material-icons-outlined" aria-hidden="true">
              chevron_right
            </mat-icon>
          </a>
          <span class="test-progress__stats">
            {{ 'liveDashboard.testmanager.progress.summary' | translate: { passRate: row.passRate, total: row.total } }}
          </span>
        </div>
        <app-stacked-bar
          [segments]="row.segments"
          [height]="10"
          [ariaLabel]="'liveDashboard.testmanager.progress.barAria' | translate: row.barAriaParams"
        />
        <div class="test-progress__legend">
          @for (item of row.legend; track item.key) {
            <span class="test-progress__legend-item">
              <span
                class="test-progress__legend-dot"
                [style.background]="'var(' + item.colorVar + ')'"
                aria-hidden="true"
              ></span>
              {{ item.count }} {{ 'liveDashboard.testmanager.legend.' + item.key | translate }}
            </span>
          }
        </div>
      </div>
    }
  </div>
</section>
